import { useState } from "react";
import {
  Box,
  Grid,
} from "@mui/material";

import SnackAlert from '@/components/snack-alert';
import ActionButtonOpen from "./ActionButton/ActionButtonOpen";
import ActionButtonClose from "./ActionButton/ActionButtonClose";
import ActionButtonAddPlateNumber from "./ActionButton/ActionButtonAddPlateNumber";
import ActionButtonHistory from "./ActionButton/ActionButtonHistory";
import ActionButtonManualPayment from "./ActionButton/ActionButtonManualPayment";
import ActionButtonTakePhoto from "./ActionButton/ActionButtonTakePhoto";

const EnterenceActionButtons = ({ 
  channelId, 
}) => {
  const [checkError, setCheckError] = useState(false);
  const [checkErrorMessage, setCheckErrorMessage] = useState('');
  return (
    <>
      <Box 
        sx={{ 
          flexGrow: 1,
          px: 1.5,
          pt: 2,
          pb: 1.5,
        }}
      >
        <Grid 
          container 
          spacing={1} 
          columns={{
            xs: 2,
          }}
        >
          <ActionButtonOpen 
            channelId={channelId}
            onCheckError={(err) => {
              setCheckErrorMessage(err)
              setCheckError(true)
            }}
          />
          <ActionButtonClose 
            channelId={channelId}
            onCheckError={(err) => {
              setCheckErrorMessage(err)
              setCheckError(true)
            }}
          />
          <ActionButtonHistory
            channelId={channelId}
          />
          <ActionButtonAddPlateNumber 
            channelId={channelId}
          />
          <ActionButtonManualPayment 
            channelId={channelId}
          />
          <ActionButtonTakePhoto 
            channelId={channelId}
          />
        </Grid>
      </Box>
      <SnackAlert
        autoHideDuration={5000}
        severity="error"
        variant="filled"
        onClose={() => setCheckError(false)}
        message={checkErrorMessage}
        open={checkError}
        sx={{ mb: 10 }}
      />
    </>
  );
}

export default EnterenceActionButtons;